import { SmartNavigationCircle } from "@/components/r3f/controls/smart-navigation/smart-navigation-circle";
import { ClippingBoxViewControls } from "@/components/ui/clipping-box-view-controls";
import { useAppSelector } from "@/store/store-hooks";
import { selectActiveWizardStepKey } from "@/store/wizard/wizard-selectors";
import { useBoxControlsContext } from "@/utils/box-controls-context";
import { useBreakpointMdUp } from "@faro-lotv/flat-ui";
import type { JSX } from "react";
import { IpxCheckoutDialog } from "./ipx-checkout-dialog";
import { IpxOrderStepKey } from "./ipx-order-steps";
import { recenterIpxViewEvent } from "./ipx-view-events";

/** @returns the in-scene tools of the active step, and the IPX checkout once the user continues to it */
export function IpxOrderModeOverlay(): JSX.Element {
  return (
    <>
      <AreaTools />
      <SmartNavigationCircle />
      <IpxCheckoutDialog />
    </>
  );
}

/** @returns the in-scene tools of the data and review steps: reset and fit the box while editing it, recenter and switch the camera */
function AreaTools(): JSX.Element | null {
  const stepKey = useAppSelector(selectActiveWizardStepKey);
  const isMdUp = useBreakpointMdUp();
  const { autoBoxEvent, resetBoxEvent } = useBoxControlsContext();

  const isEditingBox = stepKey === IpxOrderStepKey.defineArea;
  if (!isEditingBox && stepKey !== IpxOrderStepKey.review) return null;

  return (
    <ClippingBoxViewControls
      onResetBox={isEditingBox ? () => resetBoxEvent.emit() : undefined}
      // The box handles can't be dragged on touch screens, there the box is fitted to the view instead
      onFitBoxToView={isEditingBox ? () => autoBoxEvent.emit() : undefined}
      onRecenterView={() => recenterIpxViewEvent.emit()}
      // Small screens keep only the essential tools, to fit above the step sheet
      showCameraSwitch={isMdUp}
    />
  );
}
